import type { MutationTree } from 'vuex'
import type { Notification } from '@/types/alerts'
import type { AlertsState } from './types'
import { ALERTS_MUTATIONS } from './types'

interface IAlertsMutations extends MutationTree<AlertsState> {
  [ALERTS_MUTATIONS.SET_NOTIFICATIONS](state: AlertsState, notifications: Notification[]): void
  [ALERTS_MUTATIONS.ADD_NOTIFICATION](state: AlertsState, notification: Notification): void
}

const mutations: IAlertsMutations = {
  [ALERTS_MUTATIONS.SET_NOTIFICATIONS](state, notifications) {
    state.notifications = notifications
  },
  [ALERTS_MUTATIONS.ADD_NOTIFICATION](state, notification) {
    state.notifications.push(notification)
  }
}

export default mutations
